import { gql, TypedDocumentNode } from '@apollo/client'
import type { EducationDegreeFragment } from './__generated__/EducationDegreeFragment'

export const educationDegreeFragment: TypedDocumentNode<EducationDegreeFragment> = gql`
  fragment EducationDegreeFragment on EducationDegree {
    id
    name(locale: $locale)
  }
`
